import qs from 'query-string';
import FacilitySearchRequestList from '@/pc/ts/components/pages/list/FacilitySearchRequestList.vue';
import Vue from "vue";

// 画像スライダーの実装に使用しているJQueryプラグイン「flexslider」は、GlobalスコープのJQueryを参照する必要がある。
// その為、GlobalスコープのJQueryをアドホックに定義している。
declare global {
  interface Window {
    $: JQueryStatic;
  }
}

$(window).on('load', async () => {
  if (0 !== Object.keys(qs.parse(location.search)).length) {
    $('html,body').animate(
      { scrollTop: (<any>$($('.narrowDownArea')).offset()).top },
      1
    );
  }
});

$(() => {
  new Vue({
    render: h => h(FacilitySearchRequestList)
  }).$mount('#requestListBox');

  const queryString = qs.parse(location.search);
  const prefId = Array.isArray(queryString.pref_id)
    ? queryString.pref_id.slice(-1)[0]
    : queryString.pref_id;
  const orderBy = Array.isArray(queryString.od)
    ? queryString.od.slice(-1)[0]
    : queryString.od;
  const doSubmit = (path: string, p: {}): void => {
    location.href = `${path}?${qs.stringify(p, { sort: false })}`;
  };

  window.$('.flexslider.photo').flexslider({
    animation: 'fade',
    controlNav: 'thumbnails'
  });

  $<HTMLInputElement>('.js-submit-step').on('click', () => {
    location.href = "/step/snr_step/step_init.html";
  })

  $<HTMLAnchorElement>('.js-change-page').on('click', ev => {
    // eslint-disable-next-line @typescript-eslint/camelcase
    doSubmit('', { pref_id: prefId, od: orderBy, p: ev.currentTarget.dataset.page })
  });

  $<HTMLAnchorElement>('.js-change-order').on('click', ev => {
    // eslint-disable-next-line @typescript-eslint/camelcase
    doSubmit('', { pref_id: prefId, od: ev.currentTarget.dataset.order })
  });
});
